import type { ReactNode } from 'react';
import { cn } from '../utils';

export function HeaderActions({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn('flex shrink-0 items-center gap-1', className)}>{children}</div>;
}
